import { createSlice } from '@reduxjs/toolkit';
import { login, logout, refresh } from '../actions/authActions';
import { jwtDecode } from 'jwt-decode';
import { decryptData } from 'controller/constants';

const initialState = {
    user: localStorage.getItem('user') ? decryptData(localStorage.getItem('user')) : null,
    access_token: localStorage.getItem('access_token') ? decryptData(localStorage.getItem('access_token')) : null,
    isLoggedin: localStorage.getItem('isLoggedin') ? decryptData(localStorage.getItem('isLoggedin')) === 'true' : false,
    error: null,
    loading: false,
};


const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(login.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(login.fulfilled, (state, action) => {
                state.user = jwtDecode(action.payload);
                state.access_token = action.payload;
                state.isLoggedin = true;
                state.error = null;
                state.loading = false;
            })
            .addCase(login.rejected, (state, action) => {
                state.error = action.payload;
                state.loading = false;
            })
            .addCase(logout.fulfilled, (state) => {
                state.user = null;
                state.access_token = null;
                state.isLoggedin = false;
                state.error = null;
                state.loading = false;
            })
            .addCase(refresh.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(refresh.fulfilled, (state, action) => {
                state.user = jwtDecode(action.payload);
                state.access_token = action.payload;
                state.isLoggedin = true;
                state.error = null;
                state.loading = false;
            })
            .addCase(refresh.rejected, (state, action) => {
                state.error = action.payload;
                state.user = null;
                state.access_token = null;
                state.isLoggedin = false;
                state.loading = false;
            });
    },
});

export default authSlice.reducer;